import React, { memo } from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import Skeleton from '@pedidosya/web-fenix/system/Skeleton';
import Card from '@components/CardContainer';

import SectionTitle from '@shopDetails/components/Shimmer/Title';

const Container = styled.div`
  ${({ isDesktopLayout, theme }) =>
    isDesktopLayout
      ? css`
          margin: ${theme.spacing(8, 0, 0, 0)};
        `
      : css`
          margin: ${theme.spacing(8, 0, 0, 8)};
        `}
`;

const CardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  flex-wrap: nowrap;
  overflow-x: hidden;
`;

const CardShimmer = styled(Card)`
  margin: ${({ theme }) => theme.spacing(0)};
  padding: ${({ theme }) => theme.spacing(0, 0, 8, 0)};
  flex-direction: column;
  min-width: 192px;
`;

const Content = styled.div`
  margin: ${({ theme }) => theme.spacing(8)};
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(6)};
`;

const Image = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const TitleShimmer = styled(Skeleton)`
  margin-bottom: ${({ theme }) => theme.spacing(7)};
`;

const ProductCardShimmer = () => (
  <CardShimmer>
    <Image>
      <Skeleton height="25" width="25" />
    </Image>
    <Content>
      <TitleShimmer height="8" width="30" />
      <Skeleton height="8" width="20" />
      <Skeleton height="8" width="15" />
    </Content>
  </CardShimmer>
);

const cards = [1, 2, 3, 4, 5, 6];

const SwimlaneShimmer = ({ isDesktopLayout }) => (
  <Container isDesktopLayout={isDesktopLayout}>
    <SectionTitle />
    <CardsContainer>
      {cards.map(card => (
        <ProductCardShimmer id={card} key={card} />
      ))}
    </CardsContainer>
  </Container>
);

SwimlaneShimmer.propTypes = {
  isDesktopLayout: PropTypes.bool,
};

SwimlaneShimmer.defaultProps = {
  isDesktopLayout: false,
};

export default memo(SwimlaneShimmer);
